import validationDictionary from "@/data/daily/validation-dictionary.json";

/**
 * Sanitizes user input for guess submission.
 * - Removes HTML tags.
 * - Removes non-alphabetic characters.
 * - Converts to uppercase and slices to 5 characters.
 */
export function sanitizeGuess(input: string): string {
  const withoutTags = input.replace(/<[^>]*>/g, "");
  const alphaOnly = withoutTags.replace(/[^a-zA-Z]/g, "");
  return alphaOnly.toUpperCase().slice(0, 5);
}

/**
 * Checks if a 5-letter word exists in the dictionary of valid words.
 */
export function isValidWord(word: string): boolean {
  if (word.length !== 5) return false;
  const upper = word.toUpperCase();
  const dict = validationDictionary as string[];
  return dict.includes(upper);
}
